// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__XObpu","fileBtn":"File_fileBtn__2JW6i","closeBtn":"File_closeBtn__2bwsq","fileSelected":"File_fileSelected__3N5ZU","disabled":"File_disabled__ucOrn"};